import {useParams, useNavigate} from "react-router-dom";
import {Alert, Tag} from "antd";
import {Button, FontAwesomeIcon, Loading, PageHeader, ProjectToolNav} from "~/components";
import {useGetCrawlPageQuery} from "~/reduxs/api/crawlerApiSlice";
// Tái dùng nguyên component kết quả chấm điểm đơn trang (ScoreOverview + CrawlSummary
// + CriteriaGroup) từ eval_json đã lưu — không cần preview iframe cho crawler.
import SeoResult from "~/features/SeoCheck/components/SeoResult";

/** Diễn giải lý do trang không có dữ liệu chấm điểm theo HTTP status. */
function failureReason(data) {
	const code = data.status_code || 0;

	if (code === 0) {
		return 'Không kết nối được tới trang (hết thời gian chờ, lỗi DNS hoặc máy chủ từ chối kết nối).';
	}
	if (code >= 300 && code < 400) {
		return data.redirect_to
			? `Trang chuyển hướng (HTTP ${code}) tới: ${data.redirect_to}. Nội dung được chấm ở URL đích nếu URL đó nằm trong phạm vi crawl.`
			: `Trang chuyển hướng (HTTP ${code}) nên không có nội dung để chấm.`;
	}
	if (code === 401 || code === 403) {
		return `Trang chặn truy cập (HTTP ${code}) — cần đăng nhập hoặc bot bị từ chối.`;
	}
	if (code === 404 || code === 410) {
		return `Trang không tồn tại (HTTP ${code}) — liên kết trỏ tới đây là liên kết hỏng, nên sửa hoặc gỡ.`;
	}
	if (code >= 400 && code < 500) {
		return `Máy chủ từ chối yêu cầu (HTTP ${code}).`;
	}
	if (code >= 500) {
		return `Máy chủ gặp lỗi khi trả trang (HTTP ${code}) — kiểm tra log server.`;
	}
	return 'Trang không tải được nội dung nên không được phân tích chi tiết.';
}

/**
 * Chi tiết SEO 1 trang trong crawl — nạp lại eval_json và render bằng SeoResult.
 */
function CrawlPageDetail() {

	const {id} = useParams();
	const navigate = useNavigate();

	const {data, isLoading} = useGetCrawlPageQuery(id);

	if (isLoading) return <Loading />;
	if (!data) return <div className="container">Không tìm thấy trang.</div>;

	return (
		<div className="container">
			{data.project_id > 0 && (
				<ProjectToolNav projectId={data.project_id} active="crawler"
					trail={[
						{label: `Crawl #${data.crawl_id}`, to: `/crawler/crawls/${data.crawl_id}`},
						{label: 'Chi tiết trang'},
					]} />
			)}

			<PageHeader
				icon="fa-light fa-file-magnifying-glass"
				title="Chi tiết trang"
				subtitle={data.url}
				actions={
					<Button white onClick={() => navigate(-1)}
						leftIcon={<FontAwesomeIcon icon="fa-light fa-arrow-left" />}>
						Quay lại
					</Button>
				}
			/>

			<div style={{marginBottom: 12}}>
				<Tag color={data.status_code >= 200 && data.status_code < 300 ? 'green' : data.status_code >= 300 && data.status_code < 400 ? 'gold' : 'red'}>
					HTTP {data.status_code || '—'}
				</Tag>
				<Tag>Độ sâu {data.depth}</Tag>
				{data.response_time_ms > 0 && <Tag>{data.response_time_ms} ms</Tag>}
				{data.redirect_count > 0 && <Tag color="gold">{data.redirect_count} lần chuyển hướng</Tag>}
				{data.is_indexable === false && <Tag color="red">noindex</Tag>}
			</div>

			{data.result ? (
				<SeoResult result={data.result} showPreview={false} />
			) : (
				<Alert type="warning" showIcon
					message="Không có dữ liệu chấm điểm"
					description={failureReason(data)}
				/>
			)}
		</div>
	);
}

export default CrawlPageDetail;
